export const MAP_MIN_ZOOM = 6
export const MAP_MAX_ZOOM = 16 // 20 would be ideal, but causes problems when printing at larger paper sizes because LM map has a max zoom of 16
export const MAP_DEFAULT_ZOOM = 12

// TODO: Remove small util files and merge the content in this file instead.
